import { Injectable } from '@angular/core';
import { NoiseAnalysisBlock } from './noise-analysis-interface';

import * as background from '../../config/backgroundColor'
import * as backgroundColor from '../../config/backgroundColor';
import * as color from '../../config/colors';
import * as toolbox from '../../config/toolbox';
import * as tooltip from '../../config/tootip';
import * as legend from '../../config/legend';
import * as xAxis from '../../config/xAxis';
import * as yAxis from '../../config/yAxis';
import * as series from '../../config/series';
import * as grid from '../../config/grid';
import * as brush from '../../config/brush';
import * as _ from 'lodash'

import { cloneDeep, isNil } from 'lodash';
import { EChartOption } from 'echarts';
import { ECharts } from 'echarts';
import { NoiseAnaliysisBlockComponent } from './noise-analiysis-block.component'

@Injectable({
  providedIn: 'root'
})
export class NoiseAnalysisBlockService {

  constructor() { }

  getChartGrid(style) {
    return grid.getNoiseAnalysisLineGrid(style)
  }

  getChartxAxis() {
    return xAxis.getXaxisOfNoiseAnalysisLine(0, [])
  }

  getChartyAxis() {
    return yAxis.getYaxisOfNoiseAnalysisLine([])
  }

  getChartToolbox() {
    return toolbox.getNoiseDropboxLineToolboxV2()
  }

  getChartBrush() {
    return toolbox.getNoiseAnalysisBrush()
  }
  getDefaultTooltip() {
    return tooltip.getNoiseDropLineTooltip()
  }



  changeChartTitleDark(component: NoiseAnaliysisBlockComponent, darkMode: boolean) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }

  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;
  }

  xAxisDarkMode(xAxisOption) {
    xAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
    });
  }

  yAxisDarkMode(yAxisOption) {
    yAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
      if (isNil(e['splitLine'])) {
        e['splitLine'] = {
          lineStyle: {
            color: color.darkModeTextColor
          }
        };
      } else {
        if (isNil(e['splitLine']['lineStyle'])) {
          e['splitLine']['lineStyle'] = {
            color: color.darkModeTextColor
          }
        } else {
          e['splitLine']['lineStyle']['color'] = color.darkModeTextColor;
        }
      }
    });
  }

  colorsDarkMode(colors: string[]) {
    colors.length = 0;
    color.darkModeColors.forEach(e => {
      colors.push(e);
    });
  }


  legendDarkMode(legendOption) {
    if (isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }

  seriesDarkMode(seriesOption: EChartOption.Series) {
    if (isNil(seriesOption['label'])) {
      seriesOption['label'] = {};
    }
    seriesOption['label']['color'] = color.darkModeTextColor;
  }

  setSmallModeGrid(gridOption: EChartOption.Grid) {
    gridOption.top = grid.baseSmallPadding;
    gridOption.bottom = grid.baseSmallPadding;
    gridOption.left = grid.baseSmallPadding;
    gridOption.right = grid.baseSmallPadding;
  }


  setLegendPosition(gridOption: EChartOption.Grid, legendOption, legendPosition: string, bcacLegendShow: boolean) {
    if (bcacLegendShow) {
      legendOption.show = bcacLegendShow;
      switch (legendPosition) {
        case "top":
          legendOption.show = bcacLegendShow;
          break;
        case "right":
          gridOption.right = legend.rightLegendWidth;
          // delete legendOption.width;
          legendOption['top'] = legendOption['itemGap'];
          // legendOption['top'] = 0;
          legendOption['right'] = gridOption.left;
          legendOption['bottom'] = gridOption.bottom;
          legendOption['width'] = gridOption.right;
          legendOption['orient'] = "vertical";
          legendOption['pageIcons'] = {
            vertical: [
              "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
              "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
            ],
          };
          legendOption['textStyle']['padding'] = [2, 0, 0, 0];
          break;
        default:
          gridOption.bottom = legend.bottomLegendHeight;
          break;
      }
    } else {
      legendOption.show = bcacLegendShow;
    }

  }

  setYnameGap(yAxisOption, yNameGap: number) {
    yAxisOption.forEach(e => {
      e.nameGap = yNameGap;
    });
  }

  chartColorsChange(colors: string[], colorList: string[]) {
    colors.length = 0;
    colorList.forEach(e => {
      colors.push(e);
    });
  }

  topLegendChange(legendDatas: any[], optionInit: ECharts) {
    legendDatas.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.label
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.label
        });
      }
    });
  }


  //todo tooltip显示格式化
  setTooltipFormat(value: string) {
    return tooltip.getNoiseAnalysisLineTooltip(value);
  }


  brushTrigger(e: any, optionInit: ECharts) {
    if (e.type == 'brush' && e.active) {
      optionInit.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'brush',
        brushOption: {
          // 参见 brush 组件的 brushType。如果设置为 false 则关闭“可刷选状态”。
          brushType: 'lineX',
          // 参见 brush 组件的 brushMode。如果不设置，则取 brush 组件的 brushMode 设置。
          brushMode: 'single'
        }
      });
    } else if (e.type == 'brush' && !e.active) {
      optionInit.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'brush',
        brushOption: {
          brushType: false,
          brushMode: 'single'
        }
      });
    } else if (e.type == 'brush_clear') {
      optionInit.dispatchAction({
        type: 'brush',
        areas: []
      });
    }
  }



  //todo 更改chartData
  changeChartData(style,chartOpt, data: NoiseAnalysisBlock) {
    let colorMap = _.zipObject(data.rectTypeLists, color.defaultColors);
    let rectlegend = []
    for (const item in colorMap) {
      rectlegend.push({
        name: item,
        textStyle: {
          fontSize: 10,
          color: colorMap[item]  //text颜色
        }
      })
    }
    let monitorItem = []
    if (data.seriesDatas && data.seriesDatas.length) {
      for(const item of data.seriesDatas){
        monitorItem.push(item.categoryName)
      }
    }
    chartOpt.legend = legend.getNoiseAnalysisLineLegend(style, monitorItem, rectlegend)
    let xInterval = data.xInterval ? data.xInterval : 0
    chartOpt.xAxis = data.xFormatter
      ? xAxis.getXaxisOfNoiseAnalysisLine(xInterval, data.xAxisDatas, data.xFormatter)
      : xAxis.getXaxisOfNoiseAnalysisLine(xInterval, data.xAxisDatas)
    chartOpt.series = series.geSeriesOfNoiseAnalysisBlock(data, colorMap)
    let catery = new Array(data.rectTypeLists.length).fill('')
    chartOpt.yAxis = yAxis.getYaxisOfNoiseAnalysisLine(catery)
    return chartOpt
  }
}
